import { useTranslation } from 'react-i18next';
import useFriends from '@/hooks/contacts/use-friends';
import type { SearchMessageResult } from '@/hooks/search/use-search-messages';
import { getDateFormatKey } from '@/utils/datetime';
import SearchListItem from './search-list-item';
import SessionLink from './session-link';

interface Props {
  keyword?: string;
  selectedMessageSet?: SearchMessageResult;
}

export default function SearchMessageResultDetail({ keyword = '', selectedMessageSet }: Props) {
  const { t } = useTranslation();
  const { friends } = useFriends();
  if (!selectedMessageSet) return null;

  return (
    <div className='relative flex-1 overflow-auto pb-safe-or-4'>
      <h4 className='sticky top-0 pt-1 mb-2 bg-neutral-0 px-5 text-body1 font-bold'>
        “{keyword}” {t('search.related-chat-record', { count: selectedMessageSet.SearchResultDetails.length })}
      </h4>

      {selectedMessageSet.SearchResultDetails.map(({ Id, HeaderImg, Message, CreateTime, NickName, UserId }) => {
        const { RemarkName } = friends[UserId] || {};

        const isGroup = 'GroupId' in selectedMessageSet && selectedMessageSet.GroupId !== 0;

        return (
          <SessionLink
            key={Id}
            messageId={Id}
            {...(isGroup ? { groupId: selectedMessageSet.GroupId } : { sessionId: selectedMessageSet.ChatSessionId })}>
            <SearchListItem
              key={Id}
              avatarImageUrl={HeaderImg}
              title={RemarkName || NickName}
              description={Message}
              highlight={keyword}
              highlightField='description'
              suffix={
                <span className='whitespace-nowrap text-body2 text-base-content/50'>
                  {getDateFormatKey(CreateTime, 'session', t)}
                </span>
              }
            />
          </SessionLink>
        );
      })}
    </div>
  );
}
